/* eslint-disable camelcase */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthTokenModel } from "app/services/api/types/authorisation/models/AuthTokenModel";
import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { AuthTokenResponse } from "app/services/api/types/authorisation/responses/AuthTokenResponse";
import { removeToken, storeToken } from "ui/utils/ManageTokens";

interface State {
  auth?: Omit<AuthTokenModel, "token_type">;
  user?: AuthUserModel;
  hash?: string;
  localRetries: number;
}

const initialState: State = {
  auth: undefined,
  user: undefined,
  hash: undefined,
  localRetries: 0,
};

export const authorisationSlice = createSlice({
  name: "authorisation",
  initialState,
  reducers: {
    storeAuthorisationToken: (
      state,
      action: PayloadAction<AuthTokenResponse & { hash?: string }>,
    ) => {
      const { token_data, user_data, hash } = action.payload;
      state.auth = token_data;
      state.user = user_data;
      state.hash = hash;
      storeToken(action.payload);
    },
    removeAuthorisationToken: (state) => {
      state.auth = undefined;
      state.user = undefined;
      removeToken();
    },
    increaseLocalRetries: (state) => {
      state.localRetries = state.localRetries + 1;
    },
    resetLocalRetries: (state) => {
      state.localRetries = 0;
    },
  },
});

export const {
  storeAuthorisationToken,
  removeAuthorisationToken,
  increaseLocalRetries,
  resetLocalRetries,
} = authorisationSlice.actions;

export const selectHasToken = (state: { authorisation: State }) =>
  !!state.authorisation.auth?.token;

export default authorisationSlice.reducer;
